<div class="modal fade" bsModal #recordsModal="bs-modal" [config]="{backdrop: 'static'}"
     tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title pull-xs-left">{{title}}</h4>
                <button type="button" class="close float-sm-right" aria-label="Close" (click)="closeModal()">
                    <span aria-hidden="true"><img src="assets/img/icon-close-reversed.png"></span>
                </button>
            </div>
            <div class="modal-body">
                {{modalBodyText}}
            </div>
            <div class="modal-footer">
                <div class="float-left text-align-left">
                    <button class="btn btn-primary" (click)="closeModal()">Cancel</button>
                </div>
                <div class="float-right text-align-right">
                    <button (click)="generateExcel()" class="btn btn-primary" [disabled]="!hideSpinner">
                        <img src="assets/img/loading.gif" height="25" width="25" [hidden]="hideSpinner">Download</button>
                </div>
            </div>
        </div>
    </div>
</div>